export const careCover = {
  title: `KASCHMIR-PFLEGE`,
  description: `Kaschmir-Pflege war noch nie so schnell und einfach! Mit dieser einfachen Anweisung können Sie nicht nur Ihren Geldbeutel schonen, sondern ersparen sich auch den Weg zur Reinigung. Nicht jeder Kaschmir muss in die Trockenreinigung. Sie können Ihr Kleidungsstück entweder von Hand oder maschinell waschen, solange es nicht auf dem Pflegeetikett Ihres Kaschmirprodukts angegeben ist.`,
  imgSrc: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/cover_img.jpg?v=1607392263`,
  videoSrc: `https://www.youtube.com/embed/SD-zRdHE5n8`,
};

export const threeType = {
  title: `Es gibt drei Arten von Kaschmirprodukten, die von GOBI Cashmere hergestellt werden:`,
  child: [
    {
      title: `Genäht - genähte Mäntel, Trenchcoats, Blazer und Anzüge`,
      svg: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/003.svg?v=1607393707`,
    },
    {
      title: `Gestrickt - Pullover, Hosen, Schals, Mützen, Handschuhe, Socken usw.`,
      svg: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/002.svg?v=1607393707`,
    },
    {
      title: `Gewebt - gewebte Decken, Schals, Tücher, Plaids, Überwürfe usw.`,
      svg: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/001.svg?v=1607393707`,
    },
  ],
};

export const twoGrid = {
  description: `Wir empfehlen Handwäsche nur für gestrickte Kleidungsstücke. Für gewebte und genähte Produkte, die bedruckt, mehrfarbig und/oder mit Seide gemischt sind, empfehlen wir unbedingt eine TROCKENREINIGUNG.`,
  child: [
    {
      imgSrc: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/q1.jpg?v=1607393687`,
    },
    {
      imgSrc: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/q2.jpg?v=1607393687`,
    },
  ],
};

export const careList = {
  title: `HANDWÄSCHE`,
  child: [
    {
      title: `SOAKING`,
      description: `In lukewarm water about 20°C (70°F), add special cashmere/wool shampoo and stir
      to dissolve evenly. Soak the garment in the wash basin, but do not leave it to soak for long.`,
      imgSrc: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/i1.jpg?v=1607396313`,
    },
    {
      title: `Waschen`,
      description: `Drücken Sie es leicht, bis es sauber ist. Um das Shampoo vollständig zu entfernen, spülen Sie es gründlich, aber vorsichtig in sauberem Wasser aus. Drücken Sie das überschüssige Wasser vorsichtig heraus, wringen Sie das Kleidungsstück jedoch nicht aus, da es sonst seine Form verliert.`,
      imgSrc: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/i2.jpg?v=1607396314`,
    },
    {
      title: `Trocknen`,
      description: `Zum Trocknen legen Sie das Kleidungsstück in seine ursprüngliche Form flach. Zum schnellen Trocknen können Sie das Kleidungsstück mit einem Handtuch rollen, aber langsam zur Faltenvermeidung, und drücken Sie es leicht. Richten Sie das Kleidungsstück nach dem Ausrollen wieder in seine ursprüngliche Form. Zum vollständigen Trocknen legen Sie es bitte flach und niemals aufgehängt oder maschinell trocknen.`,
      imgSrc: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/i3.jpg?v=1607396313`,
    },
    {
      title: `Bügeln`,
      description: `Wenn Sie danach bügeln möchten, verwenden Sie bitte ein Dampfbügeleisen und stellen Sie die Temperatur entsprechend ein. Richten Sie die Dampffunktion ein und lassen Sie zwischen dem Bügeleisen und dem Kaschmir-Kleidungsstück einen Abstand von 0,5 bis 1 cm (0,2 bis 0,4 Zoll).`,
      imgSrc: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/i4.jpg?v=1607396314`,
    },
    {
      title: `Pilling ist eine natürliche Eigenschaft`,
      description: `Bildet sich Pilling bei Ihrer Kaschmirkleidung? Machen Sie sich keine Sorgen, weil Pilling beim natürlichen Fasern vorkommt.  Pilling ist eine Knötchenbildung, die sich auf Ihrem Pullover durch Reibung ansammeln. Pilling kann schnell mit einem Kaschmirkamm oder von Hand entfernt werden.`,
      imgSrc: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/i5.jpg?v=1607396314`,
    },
    {
      title: `Aufbewahrung`,
      description: `Zur Aufbewahrung falten Sie Ihr Kaschmir-Kleidungsstück zusammen und verwenden Sie keinen Kleiderbügel, sonst er die Form ruiniert. Wenn Sie Ihr Kleidungsstück für längere Zeit aufbewahren, verwenden Sie einen Kleidersack, eine Kiste oder beides. Zum Schutz werfen Sie einen Mottenschutz in die Kiste.`,
      imgSrc: `https://cdn.shopify.com/s/files/1/0473/8377/3350/files/i6.jpg?v=1607396314`,
    },
  ],
};
